import { render, staticRenderFns } from "./shangPuGuanLi.vue?vue&type=template&id=17d4f178&scoped=true"
import script from "./shangPuGuanLi.vue?vue&type=script&lang=js"
export * from "./shangPuGuanLi.vue?vue&type=script&lang=js"
import style0 from "./shangPuGuanLi.vue?vue&type=style&index=0&id=17d4f178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4f178",
  null
  
)

export default component.exports